import { NotificationPlacement } from '@services/notification.service';
import { IAccount } from '@services/user.service';

export interface notificationCenterItem {
	heading: string;
	text: string;
	type: 'success' | 'error' | 'neutral';
	date: any;
	age?: number;
	account: IAccount;
	placement?: NotificationPlacement;
	impaired?: boolean;
}

export const dateOptions: Intl.DateTimeFormatOptions = {
	year: '2-digit',
	month: '2-digit',
	day: '2-digit',
};

export const timeOptions: Intl.DateTimeFormatOptions = {
	hour: '2-digit',
	minute: '2-digit',
	second: '2-digit',
};
